import { useState } from "react";
import { toast } from "sonner";
import api from "../lib/api";
import { errorMessage } from "../lib/errors";
import { Mail, MessageSquare, User } from "lucide-react";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/contact", form);
      setSent(true);
      toast.success("Message envoyé — nous vous répondons sous 24h ouvrées.");
    } catch (e) { toast.error(errorMessage(e, "Erreur")); }
    finally { setBusy(false); }
  };

  return (
    <div className="max-w-2xl mx-auto px-6 py-16" data-testid="contact-page">
      <div className="text-xs uppercase tracking-widest text-gold-700 font-mono mb-3">Nous écrire</div>
      <h1 className="font-display text-4xl md:text-5xl text-ink-900">Une question ? On est là.</h1>
      <p className="text-muted2 mt-3">On répond à tous les messages sous 24h ouvrées, promis.</p>

      {sent ? (
        <div className="glass rounded-2xl p-8 mt-10 text-center" data-testid="contact-sent">
          <div className="text-success font-display text-2xl">Message reçu ✓</div>
          <p className="text-muted2 text-sm mt-2">Notre équipe va vous répondre très vite.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="glass rounded-2xl p-6 mt-8 space-y-4">
          <div>
            <label className="text-xs uppercase tracking-widest text-gold-700 font-mono mb-1.5 block">Nom</label>
            <div className="relative">
              <User className="w-4 h-4 absolute left-3 top-3.5 text-muted2" />
              <input required value={form.name} onChange={(e)=>setForm({...form, name:e.target.value})}
                className="w-full bg-white border border-gold-200 rounded-lg pl-10 pr-3 py-3 text-ink-900 focus:outline-none focus:border-gold-400"
                data-testid="contact-name-input" />
            </div>
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-gold-700 font-mono mb-1.5 block">Email</label>
            <div className="relative">
              <Mail className="w-4 h-4 absolute left-3 top-3.5 text-muted2" />
              <input type="email" required value={form.email} onChange={(e)=>setForm({...form, email:e.target.value})}
                className="w-full bg-white border border-gold-200 rounded-lg pl-10 pr-3 py-3 text-ink-900 focus:outline-none focus:border-gold-400"
                data-testid="contact-email-input" />
            </div>
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-gold-700 font-mono mb-1.5 block">Message</label>
            <div className="relative">
              <MessageSquare className="w-4 h-4 absolute left-3 top-3.5 text-muted2" />
              <textarea required minLength={10} rows={5} value={form.message} onChange={(e)=>setForm({...form, message:e.target.value})}
                className="w-full bg-white border border-gold-200 rounded-lg pl-10 pr-3 py-3 text-ink-900 focus:outline-none focus:border-gold-400"
                data-testid="contact-message-input" />
            </div>
          </div>
          <button type="submit" disabled={busy} className="w-full px-5 py-3 rounded-full bg-gold-500 text-ink-900 font-medium hover:bg-gold-500-400 shadow-gold disabled:opacity-60" data-testid="contact-submit-button">
            {busy ? "Envoi…" : "Envoyer le message"}
          </button>
        </form>
      )}
    </div>
  );
}
